export default {

    hideMask: 'hide-mask',
    showMask: 'show-mask',

    hideModal: 'hide-modal',
    showModal: 'show-modal',
    hideModalWithoutActions: 'hide-modal-repressed',
    infoAttachmentShown: 'info-attachment-shown',
    afterModalClose: 'after-modal-close',

    passErrorToComponent: 'pass-error-to-component',

    pageTyped: 'page-typed',

    hideSubMenu: 'hide-submenu',
    toggleSubMenu: 'toggle-submenu',
    reloadCookieConsent: 'reload-cookie-consent',

    SHARED: {

        edit: 'edit',
        cancel: 'cancel',
        save: 'save',
    },
}
